import { DocumentType, Permission, SalesOrderDTO } from 'core/api';
import * as SalesOrderStore from './SalesOrderStore';

import { showDocumentPayments } from 'pos/modules/helpers/payments-processing';
import { OrderingFacade, PrintFacade } from 'pos/facades';
import { Command } from 'pos/common';
import { Preconditions } from 'core/infrastructure-next';

declare global {
	interface CommandType {
		showSalesOrderPayments: (order: SalesOrderDTO) => Promise<Result>
	}
}

Command.register('showSalesOrderPayments', Preconditions.ensureIsNotLite, async (order: SalesOrderDTO): Promise<Result> => {
	return showDocumentPayments({
		addPaymentPermission: Permission.SalesOrder_AddPayment,
		removePaymentPermission: Permission.SalesOrder_RefundPayment,
		getTicket: () => OrderingFacade.getTicket(order.TicketId),
		updatePayments: (payments, prepayAmount) => SalesOrderStore.addPayments(order.Id, payments, prepayAmount),
		documentType: 'SalesOrder',
		printDocument: async () => {
			const printParams = await PrintFacade.getPrintOptions(DocumentType.SalesOrder);
			await SalesOrderStore.print(order.Id, { contentReplacement: '', printer: printParams.Printer, printTemplate: printParams.Template });
		}
	});
});